const Datastore = require('nedb')

let movements = new Datastore({ filename: "./movements.db", autoload: true });

export default movements;


// WEBPACK FOOTER //
// ./src/services/movements/index.js